"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = parseInt;
//# sourceMappingURL=to-integer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/to-integer.js
// module id = 1154
// module chunks = 37